<template>
    <section :class="['parametric-results', {'is-processing': isProc}]">
        <div ref="cards" v-if="flats.length" class="parametric-results__cards">
            <div class="parametric-results__cards-top">
                <ul class="parametric-results__cards-sort">
                    <!-- Если влезут можно добавить и эти -->
                    <!--<li><Sort :name="'Квартира'" :type="'type'"/></li>-->
                    <li v-if="!isEstateFlat"><Sort :name="'Площадь'" :type="'area'"/></li>
                    <li v-if="isEstateFlat"><Sort :name="'Этаж'" :type="'floor'"/></li>
                    <li><Sort :name="'Сдача'" :type="'deadline'"/></li>
                    <li><Sort :name="'Цена'" :type="'price'"/></li>
                </ul>

                <ButtonCheckbox
                    modify="parametric-results__cards-booked"
                    value="Забронированные"
                    :toggle="true"
                    :checked="bookFilter"
                    @click="toggleBooked" />
            </div>

            <div class="parametric-results__cards-items">
                <Card v-for="flat in showFlats" :flat="flat" :key="flat.id" :booked="bookFilter"/>
            </div>
        </div>

        <div v-if="counterHidden > 0" class="parametric-results__button-more">
            <More
                :counterHidden="counterHidden"
                :counterFlats="this.flats.length"
            />
        </div>

        <div v-if="!flats.length" class="parametric-results__no-result">
            <DustRunnerIcon/>
            <h4 class="parametric-results__no-result-title">Вы совершили невозможное!</h4>
            <p class="parametric-results__no-result-description">
                {{ isEstateFlat ? 'Квартир' : 'Коммерческих помещений' }} не найдено. Пожалуйста, измените параметры
                фильтра
            </p>
            <ArrowIcon/>
        </div>

        <button
            v-if="!isMobile && !isFilterOpen"
            ref="buttonUp"
            :class="['button', 'button_theme_black', 'button_theme_icon', 'parametric-filters__up',
                {'is-static': buttonUpIsStatic},
                {'is-fixed': buttonUpIsFixed}]"
            @click="scrollToTop">
            Фильтровать
            <UpIcon />
        </button>
    </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import ArrowIcon from '../svg-media/arrow.vue';
import ButtonCheckbox from 'components/button-checkbox/ButtonCheckbox.vue';
import Card from './Card/Card.vue';
import {debounce} from 'throttle-debounce';
import DustRunnerIcon from '../svg-media/dustrunner.vue';
import More from '../More/More.vue';
import ScrollBy from 'components/scrollBy';
import Sort from '../Sort/Sort.vue';
import UpIcon from '../svg-media/up.vue';
import Utils from 'common/scripts/utils';

const scrollBy = new ScrollBy();

export default {
    data() {
        return {
            isShowPanel     : false,
            isScrollUp      : false,
            scrollPosition  : 0,
            buttonUpIsStatic: false,
            buttonUpIsFixed : false,
            bookFilter      : false
        };
    },

    components: {
        ArrowIcon,
        ButtonCheckbox,
        Card,
        DustRunnerIcon,
        More,
        Sort,
        UpIcon
    },

    props: ['isFilterOpen'],

    computed: {
        ...mapGetters({
            isMobile    : 'GET_IS_MOBILE',
            view        : 'GET_VIEW',
            flats       : 'GET_FLATS',
            page        : 'GET_PAGE',
            isProc      : 'GET_IS_PROCESSING',
            estateType  : 'GET_ESTATETYPE',
            hiddenPrices: 'GET_HIDDENPRICES'
        }),

        // Количество показанных, складывается из текущей страницы и настройки.
        counterVisible() {
            return this.page * this.$appOptions.showItemPage;
        },

        // Количество скрытых, разница между общим количеством и уже показанных.
        counterHidden() {
            return this.flats.length - this.counterVisible;
        },

        showFlats() {
            if (!this.flats.length) {
                return false;
            }

            let filteredFlats = this.flats;

            if (this.bookFilter) {
                filteredFlats = filteredFlats.filter((item) => {
                    return !item.isBooked;
                });
            }

            return filteredFlats.filter((item, index) => {
                return index < this.counterVisible;
            });
        },
        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    created() {
        this.bindEvents();
        this.showSortPanel();
    },

    mounted() {
        this.changeStateButtonUp();

        scrollBy.init();
    },

    watch: {
        page() {
            this.changeStateButtonUp();
        }
    },

    methods: {
        ...mapActions(['changeFilter']),

        bindEvents() {
            window.addEventListener('resize', this.showSortPanel);

            window.addEventListener('scroll', debounce(10, () => {
                this.changeStateButtonUp();
            }));
        },

        showSortPanel() {
            if (Utils.isBreakpoint(320, 670)) {
                this.bindScrollEvents();
            } else {
                this.unbindScrollEvents();
                this.isShowPanel = false;
                this.isScrollUp = false;
            }
        },

        bindScrollEvents() {
            window.addEventListener('scroll', this.setPanelState);
        },

        unbindScrollEvents() {
            window.removeEventListener('scroll', this.setPanelState);
        },

        setPanelState() {
            if (this.$refs.cards) {
                this.isShowPanel = this.$refs.cards.getBoundingClientRect().top <= 0 &&
                    this.$refs.cards.getBoundingClientRect().bottom >= 0;

                this.isScrollUp = document.body.getBoundingClientRect().top > this.scrollPosition &&
                    this.$refs.cards.getBoundingClientRect().top <= 0;

                this.scrollPosition = document.body.getBoundingClientRect().top;
            }
        },

        changeStateButtonUp() {
            if (Utils.isBreakpoint(0, 1280)) {
                return;
            }

            const filtersInner = this.$parent.$refs.filter.$refs.filtersInner;
            const isFilterViewport = Utils.isInViewport(filtersInner);
            const currentScroll = window.scrollY + window.innerHeight;
            const parametricHeight = this.$parent.$el.offsetHeight;
            const filterHeight = filtersInner.offsetHeight + filtersInner.offsetTop;

            if (filterHeight === parametricHeight) {
                return;
            }

            if (!isFilterViewport && (parametricHeight > currentScroll)) {
                this.buttonUpIsStatic = false;
                this.buttonUpIsFixed = true;
            }

            if (isFilterViewport || !(parametricHeight > currentScroll)) {
                this.buttonUpIsStatic = true;
                this.buttonUpIsFixed = false;
            }

            if (isFilterViewport) {
                this.buttonUpIsStatic = false;
                this.buttonUpIsFixed = false;
            }
        },

        scrollToTop() {
            scrollBy.scrollToTop();
        },

        toggleBooked() {
            this.bookFilter = !this.bookFilter;
        }
    }
};
</script>
